import { Route, Routes } from "react-router-dom";
import KanbanBoard from "./components/kanbanDashboard/KanbanBoard";
import PrivateRoutes from "./config/PrivateRoutes";
import ForgotPassword from "./pages/forgot-password";
import Login from "./pages/login";
import NewShipment from "./pages/NewShipment";
import NotFoundPage from "./pages/NotFoundPage";
import PurchaseOrderEnquiry from "./pages/PurchaseOrderEnquiry";
import PurchaseOrderGateway from "./pages/PurchaseOrderGatewayPage";
import PurchaseOrderPage from "./pages/PurchaseOrderPage";
import ShipmentEnquiryPage from "./pages/ShipmentEnquiryPageNew";
import ShipmentListPage from "./pages/ShipmentListPage";
import ShipmentDetentionPage from "./pages/ShipmentDetentionPage";
import StockDetailPage from "./pages/StockDetailPage";
import StockPage from "./pages/stockPage";
import SupplierEnquiryPage from "./pages/SupplierEnquiryPage";
import SupplierPage from "./pages/SupplierPage";
import UserPage from "./pages/UserPage";
import VerifyOtp from "./pages/Verifyotp";
import ForwarderDetails from "./pages/ForwarderDetails";
import ForwarderList from "./pages/ForwarderList";
import ResetPassword from "./pages/ResetPassword";
import TestingPage from "./pages/TestingPage";
import NewSupplier from "./pages/NewSupplier";
import DocumentListPage from "./pages/DocumentListPage";
import UserDetails from "./pages/UserDetails";
import OrgPage from "./pages/OrgPage";
import NewOrg from "./pages/NewOrg";
import WarehouseMainPage from "./pages/settings/WarehouseMainPage";
import WarehouseDetailsPage from "./pages/settings/WarehouseDetailsPage";
import WarehouseUnloadingPlan from "./pages/WarehouseUnloadingPlan";
import ContainerOnSiteList from "./pages/ContainerOnSiteList";
import PurchaseOrderDetailsPage from "./pages/purchase-order/PurchaseOrderDetailsPage";
import PurchaseOrderGatewayPage from "./pages/purchase-order/PurchaseOrderGatewayPage";
import PurchaseOrderShipmentRequestPage from "./pages/purchase-order/PurchaseOrderShipmentRequestPage";
import Homepage from "./pages/Homepage";

const App = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/otp/verify" element={<VerifyOtp />} />

      <Route element={<PrivateRoutes />}>
        <Route path="/" element={<Homepage />} exact />
        <Route path="/delivery-planner" element={<KanbanBoard />} />
        <Route path="settings/supplier" element={<SupplierPage />} />
        <Route path="settings/org" element={<OrgPage />} />
        <Route path="settings/org/details" element={<NewOrg />} />
        <Route path="settings/org-profile" element={<NewOrg />} />
        <Route path="settings/supplier/details" element={<NewSupplier />} />
        <Route path="settings/supplier/supplier-details" element={<SupplierEnquiryPage />} />
        <Route path="settings/warehouse">
          <Route index element={<WarehouseMainPage />} />
          <Route path=":warehouseId?/details" element={<WarehouseDetailsPage />} />
        </Route>
        <Route path="/settings/user-roles" element={<UserPage />} />
        <Route path="/stock-page" element={<StockPage />} />
        <Route path="/stock-detail" element={<StockDetailPage />} />
        <Route
          path="/shipment/purchase-order"
          element={<PurchaseOrderPage />}
        />
        <Route
          path="/purchase-order-enquiry"
          element={<PurchaseOrderEnquiry />}
        />
        <Route path="/kanban" element={<KanbanBoard />} />
        <Route path="/gateway" element={<PurchaseOrderGateway />} />
        <Route path="/shipment" element={<NewShipment />} />
        <Route path="/detention" element={<ShipmentDetentionPage />} />
        <Route
          path="/shipment-gateway/shipment-details"
          element={<ShipmentEnquiryPage />}
        />
        <Route path="/shipment-gateway" element={<ShipmentListPage />} />
        <Route path="/settings/freight-forwarder" element={<ForwarderList />} />
        <Route path="/forwarder-details" element={<ForwarderDetails />} />
        <Route path="/test/run-tests" element={<TestingPage />} />
        <Route path="/document" element={<DocumentListPage />} />
        <Route path="/settings/user/details" element={<UserDetails />} />
        <Route path="/containers-on-site" element={<ContainerOnSiteList />} />
        <Route
          path="/warehouse-unloading-plan"
          element={<WarehouseUnloadingPlan />}
        />
        <Route path="/purchase-order">
          <Route index element={<PurchaseOrderGatewayPage />} />
          <Route path="new" element={<PurchaseOrderDetailsPage key="new" />} />
          <Route path="details" element={<PurchaseOrderDetailsPage key="details" />} />
          <Route path="new-shipment-request" element={<PurchaseOrderShipmentRequestPage />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default App;
